import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatCurrency = str => {
  if (!str) return "";

  return Number(str).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

export const formatDate = date => {
  return date ? format(parseISO(date), "P", { locale: ptBR }) : "";
};

export const formatHour = time => {
  if (time && typeof time === "string" && /^\d{2}:\d{2}:\d{2}$/.test(time)) {
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes}`;
  }

  return "";
};
